import HeroBanner from '../components/consteNew/HeroBanner';
import NewPlanCards, { ComparisonProvider } from '../components/consteNew/NewPlanCards';
import ComparisonSection from '../components/consteNew/ComparisonSection';
import BannerSection from '../components/consteNew/BannerSection';
import WhyChooseSection from '../components/consteNew/WhyChooseSection';
import ScrollReveal from '../components/consteNew/ScrollReveal';
import { AppWrapper } from '../components/consteNew/styles/components';
import { useState } from 'react';
import BannerSection2 from './consteNew/BannerSection2';
import DiscoverAllPlanns from './consteNew/DiscoverAllPlanns';

function ConsteNew() {
  const [comparisonData, setComparisonData] = useState<any[] | null>(null);

  return (
    <ComparisonProvider value={{ comparisonData, setComparisonData }}>
      <AppWrapper>
        <BannerSection2/>
        {/* <HeroBanner /> */}
        <ScrollReveal delay={0.2}>
                    <NewPlanCards />
                  </ScrollReveal>
        <ScrollReveal delay={0.2}>
            <ComparisonSection />
        </ScrollReveal>
        {/* <ScrollReveal delay={0.2}>
          <BannerSection />
        </ScrollReveal> */}
        <ScrollReveal delay={0.2}>
          <WhyChooseSection />
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
         <DiscoverAllPlanns/>
        </ScrollReveal>
      </AppWrapper>
    </ComparisonProvider>

  );
}

export default ConsteNew;
